module.exports = __webpack_public_path__ + "static/img/szafa_9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_9.svg
// module id = cetb
// module chunks = 0